import { useEffect } from "react"

import styled from "styled-components"
import {
  selectUserAgreementTitle,
  selectUserAgreementTextContent,
  selectIsUserAgreementModalOpen,
} from "features/user/user-agreement/model/selectors/userAgreementSelectors"
import { useAppDispatch, useAppSelector } from "shared/config/store"
import { getUserAgreementThunk, setIsUserAgreementModalClose } from "features/user/user-agreement/model/slice/userAgreementModalSlice"
import { Modal, Typography } from "shared/ui"

export function UserAgreementModal () {
  const { Title } = Typography
  const title = useAppSelector(selectUserAgreementTitle)
  const textContent = useAppSelector(selectUserAgreementTextContent)
  const isUserAgreementModalOpen = useAppSelector(selectIsUserAgreementModalOpen)
  const dispatch = useAppDispatch()

  useEffect(() => {
    if (isUserAgreementModalOpen) {
      dispatch(getUserAgreementThunk())
    }
  }, [dispatch, isUserAgreementModalOpen])

  const handleClose = () => {
    dispatch(setIsUserAgreementModalClose())
  }

  return (
    <Modal open={isUserAgreementModalOpen}
      footer={null}
      width={800}
      onCancel={handleClose}
      styles={{
        body: {
          maxHeight: '600px', 
          overflowY: 'auto',
          padding: '20px'
        }
      }}
    >
      <Title>
        {title}
      </Title>

      <SContentContainer>
        <Typography.Text>
          <div dangerouslySetInnerHTML={{ __html: textContent }} />
        </Typography.Text>
      </SContentContainer>
    </Modal>
  )
}

const SContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`